import { render, staticRenderFns } from "./AddToWishlistButton.vue?vue&type=template&id=0ffb562a&scoped=true&"
import script from "./AddToWishlistButton.vue?vue&type=script&lang=js&"
export * from "./AddToWishlistButton.vue?vue&type=script&lang=js&"
import style0 from "./AddToWishlistButton.vue?vue&type=style&index=0&id=0ffb562a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffb562a",
  null
  
)

export default component.exports